import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import { useSelector, useDispatch } from "react-redux";
import { gotoNextPage, gotoPreviousPage } from "../../../../redux/actions";



export default function BasicPagination() {

const themeData = useSelector((state) => state.touchless.theme);
const {
  name,
  primary_color = "#77cf12",
  secondary_color = "white",
  text_button_color = "white",
} = themeData || {};
const effectiveTextColor = text_button_color || secondary_color;

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: '1.5rem',
    "& > *": {
      marginTop: theme.spacing(2),
      justifyContent: "center",
      display: 'flex'
    },
    "& .MuiPaginationItem-icon": {
      color: "#2196f3",
      backgroundColor: "white",
      borderRadius: "50%",
      width: "32px",
      height: "100%",
      outline: "none",
    },
    "& .MuiPaginationItem-root": {
      backgroundColor: "#ffffffad",
      color: "#2196f3",
      fontWeight: 'bold'
    },
    "& .Mui-selected": name === "default"
      ? {
          color: "white",
          backgroundImage: "linear-gradient(#77cf12 0%, #008906 100%)",
          boxShadow: `#77cf12 0px 4px 7px`,
          outline: "none",
          fontWeight: 'bold'
        }
      : {
          color: effectiveTextColor,
          backgroundColor: primary_color,
          boxShadow: `${primary_color} 0px 4px 7px`,
          outline: "none",
          fontWeight: 'bold'
        },
        "& .MuiButtonBase-root.MuiPaginationItem-root":  name === "default" ?
         {
          color:"white", 
          backgroundColor: "lightgray", 
        }:
        {
          color:effectiveTextColor, 
          backgroundColor: primary_color, 
        },
  },
}));



  const classes = useStyles();

  const [page, setPage] = useState(1);
  
  const count = useSelector(state => state.touchless.count);
  const limit = useSelector(state => state.touchless.limit);

  const pageCount = Math.ceil(count / limit);


  const dispatch = useDispatch();

  const handleSelect = (_, newPage) => {
    if(newPage === page + 1) {
      dispatch(gotoNextPage());
      setPage(newPage);
    } else if(newPage === page -1) {
      dispatch(gotoPreviousPage());
      setPage(newPage);
    }
  };

  if(pageCount < 1) {
    return null
  }

  return (
    <div className={classes.root}>
      {pageCount>1?
      <Pagination count={pageCount} onChange={handleSelect} page={page} variant="outlined" color="primary" />
      :
      <Pagination disabled count={pageCount} onChange={handleSelect} page={page} variant="outlined" color="primary" />
      }
      
    </div>
  );
}
